import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@contexts-investor';
import { Translator, Loading } from '@components';
import { phoneMask } from '@utils';
import { useWizard } from 'react-use-wizard';

const MyDataEdit = ({ userInfo, set, get, edit }) => {
  const { t } = useTranslation();
  const { profile, loadingProfile } = useProfile();
  const { nextStep } = useWizard();

  set.setSize('47rem');

  const isPhone = (phone) =>
    /^\(?(\d{2})\)?[- ]?(\d{5})[- ]?(\d{4})$/.test(phone) ||
    /^\(?(\d{2})\)?[- ]?(\d{4})[- ]?(\d{4})$/.test(phone) ||
    /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(phone);

  if (loadingProfile) return <Loading />;

  if (profile && userInfo)
    return (
      <div className="row col-xxl-7 col-xl-6 col-md-12 col-sm-12 col-xs-12 col-12 profilepj-box">
        <div
          className="row col-xl-12 col-lg-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-start cursor-pointer profile-header-border"
          style={{ height: '10vh' }}>
          <div
            className="col-xl-3 col-lg-3 col-sm-3 d-flex col-6 align-items-center justify-content-center profile-highlight"
            style={{ height: '100%' }}
          >
            <p className="profile-menu-headers">
              <Translator path="profilePage.data" />
            </p>
          </div>
          <div
            className="col-xl-3 col-lg-3 col-sm-3 d-flex col-6 align-items-center justify-content-center"
            style={{ height: '100%' }}
            onClick={() => nextStep()}
          >
            <p className="profile-menu-headers">
              <Translator path="investment.buyTokenPage.issuer.company" />
            </p>
          </div>
          <div className="row col-12 profile-edit-row-modifier">
            <div className="row col-sm-6" style={{ margin: 0, padding: '0 0.625rem 0 0' }}>
              <label className="col-12 profile-data-labels">
                <Translator path="profilePage.name" />
              </label>
              <div className="row col-12" style={{ padding: 0, margin: 0 }}>
                <input className="col-12 profile-data-input-disabled" readOnly value={userInfo.loginLegalUser.name} />
              </div>
              <label className="col-12 profile-data-labels">
                <Translator path="profilePage.email" />
              </label>
              <div className="row col-12" style={{ padding: 0, margin: 0 }}>
                <input className="col-12 profile-data-input-disabled" readOnly value={userInfo.loginLegalUser.email} />
              </div>
            </div>
            <div className="row col-sm-6" style={{ margin: 0, padding: '0 0 0 0' }}>
              <label className="col-12 profile-data-labels">
                <Translator path="profilePage.cpf" />
              </label>
              <div className="row col-12" style={{ padding: 0, margin: 0 }}>
                <input className="col-12 profile-data-input-disabled" readOnly value={userInfo.cpf} />
              </div>
              <label className="col-12 profile-data-labels">
                <Translator path="profilePage.phone" />
              </label>
              <div className="row col-12" style={{ padding: 0, margin: 0 }}>
                <div className="input-container-profile">
                  <input
                    className="col-12 profile-data-input"
                    defaultValue={userInfo.phone}
                    maxLength={15}
                    value={get.phone}
                    onChange={(e) => set.setPhone(phoneMask(e.target.value))}
                  />
                  <i className="material-icons edit-icon-profile" style={{ color: '#ff9900' }}>
                    edit
                  </i>
                </div>
              </div>
            </div>
            <div className="row col-sm-12" style={{ margin: 0, padding: 0 }} >
              <label className="col-12 profile-data-labels">
                <Translator path="profilePage.address" />
              </label>
              <div className="row col-12" style={{ padding: 0, margin: 0 }}>
                <div className="input-container-profile">
                  <textarea
                    className=" form-control text-area profile-data-textarea"
                    defaultValue={userInfo.loginLegalUser.address}
                    value={get.address}
                    onChange={(e) => set.setAddress(e.target.value)}
                  />
                  <i className="material-icons edit-icon-profile" style={{ color: '#ff9900' }}>
                    edit
                  </i>
                </div>
                {get.loadingButton ? (
                  <button className="col-md-4 col-lg-3 col-sm-4 btn btn-orange disabled" style={{ marginTop: '2.5rem' }}>
                    <Translator path="loading" />
                  </button>
                ) : (
                  <button className="col-md-3 col-lg-3 col-sm-4 col-xxl-3 btn btn-orange"
                    style={{ marginTop: '2.5rem' }}
                    onClick={() => edit()}>
                    <Translator path="profilePage.submit" />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>


    );
};

export default MyDataEdit;
